import { styled } from "@mui/system";
import { pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { FaArrowRightArrowLeft, FaCircleXmark, FaDownload } from "react-icons/fa6";
import { FiAlertCircle } from "react-icons/fi";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const ScorecardBox = () => ({
  backgroundColor: colors.white[1],
  padding: "1rem 2rem",
  marginTop: "1.6rem",
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: "90%",
  minHeight: "75vh",
  maxHeight: "75vh",
  overflowY: "auto",
});

export const GridContainer = () => ({
  border: `1.8px solid ${colors.grey[1]}`,
  borderRadius: "0.25rem",
  marginTop: "1rem",
});

export const IndicatorGrid = () => ({
  borderBottom: `2px solid ${colors.grey[1]}`,
  paddingBottom: "0.7rem",
});

export const PerformanceCriteriaGrid = () => ({
  padding: "1rem 3rem 1rem 1rem",
});

export const TotalScoreGrid = () => ({
  backgroundColor: colors.portalColor[9],
});

export const TotalScoreContainer = () => ({
  padding: "1rem 2.5rem 0",
  justifyContent: "space-between"
});

export const ScoreGridStyle = () => ({
  padding: "1rem 2.5rem 0.3rem 0",
});

export const PerformanceIndicatorGrid = () => ({
  paddingRight: "2.5rem",
  paddingTop: "0.8rem",
});

export const TotalScoreStyle = () => ({
  marginTop: "1.8rem",
  padding: "0.6rem 1.4rem",
  backgroundColor: colors.backgroundColor[7],
  borderRadius: "0.2rem",
});

export const TotalScoreBox = () => ({
  display: "flex",
  justifyContent: "space-evenly",
  textAlign: "center",
});

export const sizing = {
  margin: { right: 2 },
  width: 140,
  height: 140,
  legend: { hidden: true },
};

export const PieChartStyle = () => ({
  [`& .${pieArcLabelClasses.root}`]: {
    fill: colors.black[17],
    fontSize: 14,
  },
});

export const AutoComplete = {
  width: "100%",
  borderRadius: "1px",
  borderColor: colors.black[13],
  paddingRight: "0.5rem",
  paddingLeft: "0.5rem",
  "& .MuiOutlinedInput-root": {
    "& input": {
      marginLeft: "0.417rem",
      borderRadius: "1px",
      padding: "0",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.black[13],
    },
  },
};

export const FaArrowRightArrowLeftIcon = styled(FaArrowRightArrowLeft as React.ComponentType)(() => ({
  fontSize: "1.05rem",
  color: colors.portalColor[30],
  margin: "0.5rem 0.5em 0 0.7rem"
}));

export const ModalContainer = () => ({
  position: "relative",
  width: "60%",
  backgroundColor: "background.paper",
  padding: "1rem 1rem 1rem 2rem",
  border: "none",
  overflowY: "auto",
});

export const BarChartContainerStyle = () => ({
  overflowX: "auto"
})

export const ModalHeaderBox = () => ({
  padding: "0 1rem 1rem 1rem",
});

export const ModalTitle = () => ({
  paddingTop: "0.4rem",
  paddingBottom: "0.5rem",
  textTransform: "uppercase"
});

export const FaCircleXmarkIcon = styled(FaCircleXmark as React.ComponentType)(() => ({
  color: colors.portalColor[30],
  fontSize: "1.4rem",
  cursor: "pointer",
}));

export const CompareNpiTextBox = () => ({
  display: "flex",
  borderLeft: `1.8px solid ${colors.grey[1]}`,
});

export const CompareNpiTextStyle = () => ({
  margin: "0.6rem 0",
  cursor: "pointer",
});

export const PeriodText = () => ({
  paddingTop: "1rem",
  paddingLeft: "0.5rem",
});

export const ScorecardModalContainer = () => ({
  position: "relative",
  width: "50%",
  backgroundColor: "background.paper",
  padding: "1rem 0rem 1rem 1.5rem",
  border: "none",
  overflowY: "auto",
  borderRadius: "0.4rem",
});

export const ScorecardModalHeaderBox = () => ({
  paddingBottom: "1rem",
});

export const ScorecardModalTitle = () => ({
  paddingTop: "0.4rem",
  paddingBottom: "0.5rem",
});

export const ScorecardDisclaimer = () => ({
  fontStyle: "italic",
  paddingTop: "0.4rem",
  paddingBottom: "0.5rem",
})

export const FiAlertCircleIcon = styled(FiAlertCircle as React.ComponentType)(() => ({
  color: colors.red[100],
  fontSize: "1.1rem",
  cursor: "pointer",
}));

export const QualifierMessage = () => ({
  paddingLeft: "0.5rem",
  display: "flex",
  alignItems: "left",
});

export const CloseButton = {
  borderRadius: "1.3rem",
  backgroundColor: colors.primary.main,
  color: colors.white[1],
  minWidth: "5rem",
};
export const IconFaDownload = styled(FaDownload as React.ComponentType)(() => ({
  testAlign: "left",
  marginRight: ".5rem",
  font: fontWeight[4],
  color: colors.white[1],
}));

export const ExportIcon = {
  testAlign: "left",
  marginRight: ".5rem",
  position: "relative",
};
export const ButtonStyle = () => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "0.3rem",
  background: colors.primary.main,
  padding: "0 0.9rem 0 0.9rem",
  height: "1.8rem",
  borderRadius: "0.8rem",
  color: colors.white[1],
  cursor: "pointer",
});

export const BarLabelStyle = () => ({
  '& .MuiBarLabel-root': {
    fontSize: '0.672rem'
  }
});

export const styleForPDF = () => ({
  borderBottom: `1px solid ${colors.borders[10]}`,
  marginRight: "1rem",
  paddingTop: "0.1rem",
  paddingLeft: "0.5rem",
});

export const styleForPeriodPDF = () => ({
  borderBottom: `1px solid ${colors.borders[10]}`,
  marginRight: "1rem",
  paddingLeft: "0.5rem",
});

export const cellBorder = { border: "1px solid #000", fontWeight: 700 };

export const headerCell = () => ({ ...cellBorder, padding: "0 0 0 0.5rem" });

export const scoreHeader = () => ({ ...cellBorder, padding: "0 0 0 0.2rem" });


export const scoreTableCell = () => ({ fontWeight: 700, padding: "0rem 0rem", display: "flex", justifyContent: "center" });

export const categoryTableCell = () => ({ ...cellBorder, textAlign: "center" })

export const labelTableCell = () => ({ border: "1px solid #000", padding: "0 0 0 1.5rem", width: "15rem" })

export const renderCellStyle = () => ({  border: "1px solid #000", padding: "0 0 0 0.5rem" })

export const baselineHeader = () => ({
  padding: "1rem 0 0.5rem 2.5rem",
});